import { requestGet, requestPost, requestPut, requestDel } from '@/api/request'

/**
 * 创建订单
 * @param { string }  order_type * - 1=命书 2=预约
 * 命书参数 start
 * @param { string }  report_id - 报告任务id
 * @param { string }  subject_name - 名字
 * @param { string }  version - 版本
 * @param { string }  language - 语言
 * @param { number }  gender - 性别
 * @param { string }  birth_date_solar - 日期
 * 命书参数 end
 * @returns
 */
export const orderCreate = (params) => {
  return requestPost({
    url: `/order/v1/create-order/`,
    data: params
  })
}

/**
 * 取消订单
 * @param { string } o_id - 订单id
 * @returns
 */
export const orderCancel = (params) => {
  return requestPost({
    url: `/order/v1/cancel-order/`,
    data: params
  })
}

/**
 * 订单支付
 * @param { string } o_id - 订单id
 * @param { string } pay_type - 支付类型 2=stripe支付 4=xendit支付
 * @param { string } stripe_way - stripe支付 2 不是的话传 1
 * @param { string } xendit_way - xendit支付 4 不是的话传 1
 * @returns
 */
export const orderCheckout = (params) => {
  return requestPost({
    url: `/order/v1/order-checkout/`,
    data: params
  })
}

/**
 * 订单支付状态查询
 * @param { string } o_id - 订单id
 * @param { string } o_type - 订单类型: 支付 pay; 退款 refund
 * @returns
 */
export const orderPaymentStatus = (params) => {
  return requestGet({
    url: `/order/v1/get-pay-order-status/`,
    params: params
  })
}

/**
 * 订单退款
 * @param { string } o_id - 订单id
 * @returns
 */
export const orderRefund = (params) => {
  return requestPost({
    url: `/order/v1/order-refund/`,
    data: params
  })
}

/**
 * 订单列表
 * @param { string } page - 页数
 * @param { string } status - 支付状态 2=已确认订单 7=支付中订单 3=支付完成 4=取消订单 6=支付失败
 * @param { string } refund_status - 退款状态 默认不传 2=全部退款
 * @param { string } order_type - 订单类型 1=命书 2=预约
 * @returns
 */
export const orderListGet = (params) => {
  return requestGet({
    url: `/order/v1/get-order-list/`,
    params: params
  })
}

/**
 * 订单详情
 * @param { string } o_id - 订单id
 * @returns
 */
export const orderDetailsGet = (params) => {
  return requestGet({
    url: `/order/v1/get-order-details/`,
    params: params
  })
}
